export const SET_MODULE = 'SET_MODULE';
export const SET_MODULE_SUCCESS = 'SET_MODULE_SUCCESS';